<template>
    <div class="flex-layout supanno-list">
        <list-layout-paper>
            <div slot="header-search">
                <div class="header-search-mb">
                    <el-radio-group v-model="valueradius" @change="selectType">
                        <el-radio label="全部"></el-radio>
                        <el-radio label="招标公告"></el-radio>
                        <el-radio label="通知公告"></el-radio>
                        <el-radio label="中标公告"></el-radio>
                        <el-radio label="项目公告"></el-radio>
                        <!-- <el-radio label="通知函"></el-radio> -->
                    </el-radio-group>
                </div>
                <div>
                    <el-input v-model="editorInfo.noticeCode" placeholder="公告编号" size="mini" clearable></el-input>
                    <el-input v-model="editorInfo.noticeTitle" placeholder="公告标题" size="mini" clearable></el-input>
                    <el-date-picker
                        v-model="editorInfo.pushTimeStart"
                        size="mini"
                        type="datetime"
                        placeholder="发布时间从"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                    <el-date-picker
                        v-model="editorInfo.pushTimeEnd"
                        size="mini"
                        type="datetime"
                        placeholder="发布时间到"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                    <span class="header-button-ml bigData-btn-search" v-has="'02000001'"><el-button type="primary" size="mini" @click="searchFn">查 询</el-button></span>
                </div>
            </div>
            <div slot="header-button" class="header-button">
                <el-tooltip effect="dark" content="刷新" placement="bottom" class="header-button-ml">
                    <el-button icon="el-icon-refresh" size="mini" @click="refreshFn"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="列配置" placement="bottom" class="header-button-ml">
                    <el-button icon="el-icon-setting" size="mini" @click="colDispose"></el-button>
                </el-tooltip>
            </div>
            <el-table slot="list" slot-scope="props" :height="props.tableHeight" v-loading="loading" :data="announceList" class="tab-list" border stripe ref="table">
                <el-table-column v-for="(item, index) in columnsList"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label"
                    :align="item.label === '公告标题' ? '' :'center'"
                    :show-overflow-tooltip="true"
                    :min-width="item.width?item.width : ''">
                    <template slot-scope="scope" >
                        <div v-if="scope.column.label === '公告编号'">
                            <span>{{scope.row.noticeCode}}</span>
                        </div>
                        <div v-else-if="scope.column.label === '公告标题'">
                            <span>{{scope.row.noticeTitle}}</span>
                            <span v-if="scope.row.isRecall === SRM_YES" class="recall-text">(此招标已废弃)</span>
                        </div>
                        <div v-else-if="scope.column.label === '公告类型'">
                            <span>{{scope.row.noticeTypeText}}</span>
                        </div>
                        <div v-else-if="scope.column.label === '状态'">
                            <span>{{scope.row.supplierBidStatusText}}</span>
                        </div>
                        <div v-else><span>{{scope.row.createTime}}</span></div>
                    </template>
                </el-table-column>
                <el-table-column prop="action" label="操作" width="210" align="center">
                    <template slot-scope="scope">
                        <span v-has="'02000002'">
                            <el-button size="mini" type="text" @click="gotoDetail(scope.row)">查看报名</el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination slot="footer"
                class="text-right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="editorInfo.pageNo"
                :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="editorInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount">
            </el-pagination>
        </list-layout-paper>
        <el-dialog :visible.sync="showModal" title="列配置" @close="dialogClose">
            <configuration :checkedList="checkedList" :selectAllColumns="selectAllColumns" ref="dialog"
                @getTableConfigList="getTableConfigList" @tableConfigClose="tableConfigClose" :columnNum='columnNum'></configuration>
        </el-dialog>
    </div>

</template>
<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import ListLayoutPaper from '@/components/lots/listLayout/Paper';
import configuration from '@/components/otpPanel/configuration-list';
import { getList } from '../../../../lsrm/api/annoMana.js';
import { SupNoticeList } from '../../../../lsrm/api/supAnnoMana.js';
import { SRM_YES } from '../../../constant/constant.js';
import { dictWithUrl } from '@/components/lots/api';
export default {
    name: 'supAnnoList',
    components: { ListLayoutPaper, configuration },
    data() {
        return {
            resourceCode: '',
            editorInfo: {
                noticeScope: '',
                bidType: '',
                noticeStatus: '',
                noticeCode: '',
                noticeTitle: '',
                pushTimeStart: dayjs().subtract(3, 'month').format('YYYY-MM-DD') + ' 00:00:00',
                pushTimeEnd: dayjs().format('YYYY-MM-DD') + ' 23:59:59',
                pageNo: 1,
                pageSize: 10
            },
            valueradius: '全部',
            total: 0,
            announceList: [],
            loading: false,
            columnNum: 100,
            showModal: false,
            checkedList: '',
            selectAllColumns: [{
                prop: 'noticeCode',
                label: '公告编号',
                width: '180'
            }, {
                prop: 'noticeTitle',
                label: '公告标题',
                width: '280'
            }, {
                prop: 'noticeTypeText',
                label: '公告类型',
                width: '180'
            }, {
                prop: 'supplierBidStatus',
                label: '状态',
                width: '180'
            }, {
                prop: 'createTime',
                label: '发布时间',
                width: '180'
            }],
            columnsList: [{
                prop: 'noticeCode',
                label: '公告编号',
                width: '180'
            }, {
                prop: 'noticeTitle',
                label: '公告标题',
                width: '280'
            }, {
                prop: 'noticeTypeText',
                label: '公告类型',
                width: '180'
            }, {
                prop: 'supplierBidStatus',
                label: '状态',
                width: '180'
            }, {
                prop: 'createTime',
                label: '发布时间',
                width: '180'
            }],
            totalCount: 1,
            dictData: [],
            SRM_YES
        };
    },
    mounted() {
        dictWithUrl('SU_NOTICE_TYPE').then(res => {
            this.dictData = res.data;
            this.loadData(this.editorInfo);
        });
        this.setConfigColumn();
    },
    methods: {
        refreshFn() {
            this.loadData(this.editorInfo);
        },
        setConfigColumn() {
            const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
            this.deepMenu(menu);
            const pramas = {
                'moduleCode': this.resourceCode,
                'subjectType': 'tenderList'
            };
            getList.get(pramas).then(res => {
                if (res.data) {
                    const datas = res && res.data.configNameCn ? res.data.configNameCn.split(',') : [];
                    const columnsList = [];
                    if (!datas.length) {
                        this.selectAllColumns.map(data => {
                            columnsList.push(data);
                        });
                    } else {
                        datas.map(title => {
                            this.selectAllColumns.map(data => {
                                if (data.label === title) {
                                    columnsList.push(data);
                                }
                            });
                        });
                    }
                    this.columnsList = columnsList;
                    const arr = [];
                    this.columnsList.forEach(el => {
                        arr.push(el.label);
                    });
                    this.checkedList = arr.join(',');
                }
            });
        },
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    this.deepFunc(childrens);
                }
            }
        },
        deepFunc(childrens) {
            for (let i = 0; i < childrens.length; i++) {
                if (childrens[i].frontUrl === this.$route.path || (childrens[i].frontUrl === '/index' && this.$route.path === '/')) {
                    this.resourceCode = childrens[i].resourceCode;
                } else {
                    this.deepMenu(childrens[i]);
                }
            }
        },
        selectType(e) {
            switch (e) {
            case '全部':
                this.editorInfo.noticeType = '';
                break;
            case '通知公告':
                this.editorInfo.noticeType = '10';
                break;
            case '招标公告':
                this.editorInfo.noticeType = '20';
                break;
            case '中标公告':
                this.editorInfo.noticeType = '30';
                break;
            case '项目公告':
                this.editorInfo.noticeType = '40';
                break;
            default:
                break;
            }
            this.loadData(this.editorInfo);
        },
        searchFn() {
            this.editorInfo.pageNo = 1;
            this.loadData(this.editorInfo);
        },
        getNoticeScope(value) {
            this.editorInfo.noticeScope = value;
        },
        getNoticeStatus(value) {
            this.editorInfo.noticeStatus = value;
        },
        getBidType(value) {
            this.editorInfo.bidType = value;
        },
        conversionData(list) {
            list.forEach(el => {
                el.noticeTypeText = this.dictData.SU_NOTICE_TYPE[el.noticeType];
                el.supplierBidStatusText = (!el.supplierBidStatus || el.supplierBidStatus === '14') ? '未报名' : '已报名';
            });
        },
        loadData(serachObj) {
            serachObj.supplierCode = this.$store.state.supplier.supplierCode;
            SupNoticeList(serachObj).then((res) => {
                if (+res.code === 0) {
                    this.announceList = res.data.list;
                    this.totalCount = res.data.totalCount;
                    if (this.announceList.length > 0) {
                        this.conversionData(res.data.list);
                    }
                }
            });
        },
        gotoDetail(row) {
            this.$router.push({ name: 'supPreviewNotice', query: { id: row.id } });
        },
        colDispose() {
            this.showModal = true;
        },
        getTableConfigList(tabelConfigList, tabelConfigName) {
            this.showModal = false;
            const pramas = {
                'configName': tabelConfigName,
                'configNameCn': tabelConfigList,
                'subjectType': 'tenderList',
                'moduleCode': this.resourceCode
            };
            getList.post(pramas).then(() => {});

            const datas = tabelConfigList.split(',');
            const columnsList = [];
            datas.map(title => {
                this.selectAllColumns.map(data => {
                    if (data.label === title) {
                        columnsList.push(data);
                    }
                });
            });
            this.columnsList = columnsList;
        },
        tableConfigClose() {
            this.showModal = false;
        },
        dialogClose() {
            this.showModal = false;
        },
        handleCurrentChange(val) {
            this.editorInfo.pageNo = val;
            this.loadData(this.editorInfo);
        },
        handleSizeChange(val) {
            this.editorInfo.pageSize = val;
            this.loadData(this.editorInfo);
        }
    },
    watch: {
        user(newVal, oldVal) {
            this.load();
        }
    },
    computed: {
        ...mapGetters(['menus'])
    }
};
</script>
<style lang="less">
.supanno-list {
    overflow: hidden;
    height: calc(100vh - 40px);

    .header-button {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        min-width:142px;
    }

    .header-button-ml {
        margin-left: 10px;
    }

    .point {
        display:inline-block;
        width:8px;
        height: 8px;
        border-radius:100%;
    }

    .tab-list.el-table {
        width: 100%;
        min-height: calc(~"100vh - 220px") !important;
        max-height: calc(~"100vh - 220px") !important;
    }

    .header-search-mb {
        margin-bottom: 10px;
    }

    .recall-text {
        color: #f96c5f;
    }
}
</style>
